import { UnstyledLink, UnstyledLinkProps } from '@sparemin/blockhead';
import usePreparePlayDestinationUrl from './usePreparePlayDestinationUrl';

export type PlaybackUnawareDestinationLinkProps<
  As extends React.ElementType = 'a',
> = UnstyledLinkProps<As>;

function PlaybackUnawareDestinationLink<As extends React.ElementType = 'a'>(
  props: PlaybackUnawareDestinationLinkProps<As>,
) {
  const { onPress } = props;
  const { anchorProps } = usePreparePlayDestinationUrl({ onPress });

  return <UnstyledLink {...props} {...anchorProps} />;
}

export default PlaybackUnawareDestinationLink;
